import React from "react";
import { ManageProfilesComponent } from "../../../components/manage-profiles-components";

export const ManageProfilesPage: React.FC = () => {
    return <ManageProfilesComponent />;
};
